import { DendromapLoader } from '@repo/ui/components/dendromap-loader';
import { lazy, Suspense } from 'react';

const PromoCodesPage = lazy(() =>
  import('@repo/ui/features/promo-codes').then((mod) => ({ default: mod.PromoCodesPage })),
);

export default function PromoCodesRoute() {
  return (
    <Suspense fallback={<DendromapLoader message="Chargement des codes promo..." />}>
      <PromoCodesPage />
    </Suspense>
  );
}
